<div class="modal-header">
  <h4>{{'Delete' | translate}}</h4>
</div>
<div class="modal-body">
  <p>{{'DoYouWantToDelete' | translate}} {{text}}?</p>
</div>
<div class="modal-footer">
  <button class="btn btn-danger" (click)="ok()">{{'Delete' | translate}}</button>
  <button class="btn btn-default" (click)="cancel()">{{'Cancel' | translate}}</button>
</div>
